module.exports = __webpack_public_path__ + "img/bancontact.7c84d93.png";